"use client"

import { makeHeaders } from '@api/apiFetcher'

// Zapytania do API wiadomości: { status, body } (także przy błędach — komunikaty z serwera).
export async function chatApi (token, path, { method = 'GET', body } = {}) {
    try {
        const res = await fetch(path, { method, headers: makeHeaders(token), body: body ? JSON.stringify(body) : undefined, cache: 'no-store' })
        const json = await res.json().catch(() => null)
        if (res.status === 401 && (json?.code === 'session_expired' || json?.code === 'account_suspended')) {
            window.dispatchEvent(new CustomEvent('spl:session-expired', { detail: { token, code: json.code } }))
        }
        return { status: res.status, body: json || {} }
    } catch (err) {
        return { status: 0, body: { success: false, errors: ['Brak połączenia z internetem. Spróbuj ponownie.'] } }
    }
}

export const errorOf = (r, fallback = 'Nie udało się. Spróbuj ponownie.') => r?.body?.errors?.[0] || fallback
